
import { 
  ActionTypes, 
  setAppsType,
  setUserInfoType,
  submitCodeType,
  setStudentInfoType
} from "./types";



export const GET_APPS_SAGA = () => ({
  type: 'GET_APPS_SAGA',
  payload: ''
});


export const SET_APPS = (payload: setAppsType[]): ActionTypes => ({
  type: 'SET_APPS',
  payload: payload
});


export const GET_USER_INFO_SAGA = () => ({
  type: 'GET_USER_INFO_SAGA',
  payload: ''
});

export const SET_USER_INFO = (payload: setUserInfoType): ActionTypes => ({
  type: 'SET_USER_INFO',
  payload: payload
});

export const GET_STUDENTS_INFO_SAGA = (payload: setUserInfoType): ActionTypes => ({
  type: 'GET_STUDENTS_INFO_SAGA',
  payload: payload
});


export const SET_STUDENTS_INFO = (payload: setStudentInfoType[]): ActionTypes => ({
  type: 'SET_STUDENTS_INFO',
  payload: payload
});


export const SUBMIT_CODE_SAGA = (payload: submitCodeType): ActionTypes => ({
  type: 'SUBMIT_CODE_SAGA',
  payload: payload
});



export const SET_BAD_TEACHER_ID = (): ActionTypes => ({
  type: 'SET_BAD_TEACHER_ID',
  payload: ''
});


export const SET_NEW_TEACHER_ID = (payload: number): ActionTypes => ({
  type: 'SET_NEW_TEACHER_ID',
  payload: payload
});


export const HIDE_TEACHER_ERROR = (): ActionTypes => ({
  type: 'HIDE_TEACHER_ERROR',
  payload: ''
});


export const LOG_OUT_SAGA = (): ActionTypes => ({
  type: 'LOG_OUT_SAGA',
  payload: ''
});



export const RECORD_ENTRY_SAGA = (payload: { [key:string]: string; }): ActionTypes => ({
  type: 'RECORD_ENTRY_SAGA',
  payload: payload
});